export const USER_EDIT_HEADER_CLASS = 'API::CompanyEmployee';
export const USER_EDIT_HEADER_TYPE = 'ENDUSER';
export const USER_EDIT_RETURN_TYPE = 'application/json';
export const USER_EDIT_CTO_REQUESTID = 'c064a288-7dGFwaTtST09UOyA=';
export const USER_EDIT_CTO_TRACKID = '1994aab4-f115-4608-9986-48cbbb070854';
